module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-32.e3fb1bdf.png";